import { c as _c } from "react/compiler-runtime";
import { Carousel, CarouselSlide } from "@mantine/carousel";
import Image from "next/image";
import { mediaUrl } from "@/lib/config/app";
import Link from "next/link";
import { Icon } from "@iconify/react";
import PureHtml from "@/components/custom/PureHtml";
export default function BrandSlider(t0) {
  const $ = _c(22);
  const {
    fbrands
  } = t0;
  const t1 = fbrands?.heading || "Popular Brands";
  let t2;
  if ($[0] !== t1) {
    t2 = <h2 className="text-xl lg:text-2xl">{t1}</h2>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = fbrands?.subtext;
  let t4;
  if ($[2] !== t3) {
    t4 = <PureHtml html={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      "aria-label": "Previous"
    };
    t6 = {
      "aria-label": "Next"
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t10;
  let t7;
  let t8;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      base: "33%",
      sm: "20%",
      md: "16%",
      lg: "11.1%"
    };
    t8 = {
      loop: true,
      align: "start",
      slidesToScroll: 1
    };
    t9 = {
      display: "flex",
      flexDirection: "column-reverse"
    };
    t10 = {
      position: "relative",
      width: "100px",
      marginLeft: "auto"
    };
    $[6] = t10;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t10 = $[6];
    t7 = $[7];
    t8 = $[8];
    t9 = $[9];
  }
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      root: t9,
      controls: t10,
      control: {
        pointerEvents: "all",
        background: "white",
        color: "black",
        width: "36px",
        height: "36px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        "&[dataInactive]": {
          opacity: 0,
          cursor: "default"
        }
      }
    };
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== fbrands?.brands) {
    t12 = fbrands?.brands?.length > 0 && fbrands?.brands?.map(_temp);
    $[11] = fbrands?.brands;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t12) {
    t13 = <Carousel withIndicators={false} previousControlProps={t5} nextControlProps={t6} slideGap="xs" slideSize={t7} emblaOptions={t8} styles={t11}>{t12}</Carousel>;
    $[13] = t12;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="viewall"><Link href="/brands" className="font-heading flex items-center gap-2">View All<Icon icon="mdi:arrow-right" /></Link></div>;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== t13) {
    t15 = <div className="grid grid-cols-1"><div className="w-full">{t13}{t14}</div></div>;
    $[16] = t13;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== t15 || $[19] !== t2 || $[20] !== t4) {
    t16 = <section className="brand-slider py-2 lg:py-3"><div className="max-w-7xl mx-auto px-2">{t2}{t4}{t15}</div></section>;
    $[18] = t15;
    $[19] = t2;
    $[20] = t4;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  return t16;
}
function _temp(fbrand, index) {
  const imageAlt = fbrand?.image_alt || fbrand?.brand_name || "Brand";
  return <CarouselSlide key={index} py="xs"><Link href={`/brands/${fbrand.brand_slug}`} title={fbrand.brand_name}><div className="relative drop-shadow drop-shadow-gray-300 bg-white rounded overflow-hidden p-4" style={{
        aspectRatio: "1/1"
      }}><Image className="object-contain" src={`${mediaUrl}${fbrand?.brand_image || "noimage.png"}`} alt={imageAlt} fill={true} sizes="(max-width: 768px) 33vw, 12vw" /></div><div className="hidden">{fbrand.brand_name}</div></Link></CarouselSlide>;
}